import React, { Component } from 'react';
import './Documents.scss';
import Button from '../Button';
import DocumentForm from '../DocumentForm';
import DocumentsRepeater from './DocumentsRepeater';
import Icon from '../Icon';
import Overlay from '../Overlay';
import Search from '../Search';
import Empty from '../Empty';
import Actions from '../Actions';
import { selectSearch } from '../../store/selectors/search';
import { connect } from 'react-redux';
import { clearFndFormData } from '../../store/actions/fndForm';
import { bindActionCreators } from 'redux';
import 'yet-another-react-lightbox/styles.css';
import { toast } from 'react-toastify';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import ContentBlock from '../ContentBlock';
import { IntroContent } from '../../common/constants';
import { getUrlExtension } from '../../helpers/CommonHelpers';
import { groupDocuments } from './DocumentGrouping';
import { DocumentGroup } from './DocumentGroup';

import download from 'downloadjs';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';

class Documents extends Component {
  state = {
    showOverlay: false,
    isOpen: false,
    selectedIndex: 0,
    selectedImage: '',
  };

  onClick = (data) => {
    if (data.includes('.mp4')) {
      toast.success(
        `Your ${this.props.labelName} download has started, It may take some time.`,
        { autoClose: 12000, position: 'top-center' }
      );
    }
    download(data);
  };

  onImageClicked(x, url, isImage) {
    if (isImage) {
      if (getUrlExtension(url) === 'heic')
        return window.open(url, '_blank').focus();
      this.setState({
        isOpen: true,
        selectedIndex: x,
        selectedImage: url,
      });
      return;
    }
    window.open(url, '_blank').focus();
  }

  render() {
    const {
      documents,
      breadcrumb,
      onSearch,
      onSaveDocument,
      search,
      clearFndFormData,
      onDeleteDocument,
      user,
      labelName,
      introContent,
      disableGrouping = false,
    } = this.props;
    const { isOpen, selectedImage } = this.state;

    const { priority, General, ...groupedDocuments } =
      groupDocuments(documents);
    let homeOwnerCheck =
      user &&
      user.roles &&
      user.roles.length > 0 &&
      (user.roles[0].role.name === 'Home Owner' ||
        user.roles[0].role.name === 'Occupant')
        ? true
        : false;
    const { showOverlay } = this.state;
    const isSearching = search && search?.documents?.length > 0 ? true : false;
    return (
      <div className="documents">
        {introContent && (
          <ContentBlock content={IntroContent.manualsAndDocuments} />
        )}
        <Actions compact>
          <Search
            size="small"
            placeholder={`${labelName}...`}
            onChange={onSearch}
          />
          {this.props.user.roles[0].role.name === 'Strata Manager' ||
          user.roles[0].role.name === 'Vendor' ||
          user.roles[0].role.name === 'Occupant' ||
          user.roles[0].role.name === 'Realtor' ||
          (homeOwnerCheck &&
            localStorage.getItem('theme') === 'Rize') ? null : (
            <Button
              color="teal"
              label={`Add ${labelName}`}
              onClick={() => {
                this.setState({ showOverlay: true });
                clearFndFormData();
              }}
              icon={<Icon glyph="file-contract" weight="light" size="small" />}
              size="small"
            />
          )}
        </Actions>
        {documents.length > 0 ? (
          <>
            {isSearching || disableGrouping ? (
              <DocumentsRepeater
                documents={documents}
                onDeleteDocument={onDeleteDocument}
                onDownload={(data) => this.onClick(data)}
                onClick={(x, data, isImage) =>
                  this.onImageClicked(x, data, isImage)
                }
                user={user}
                from={this.props.from}
              />
            ) : (
              <>
                {/* Document Groups */}
                {priority.length > 0 && (
                  <DocumentGroup
                    name="Priority"
                    documents={priority}
                    defaultExpanded
                    onDownload={(data) => this.onClick(data)}
                    {...{ onDeleteDocument, user }}
                    onClick={(idx, url, isImage) =>
                      this.onImageClicked(idx, url, isImage)
                    }
                  />
                )}
                {Object.keys(groupedDocuments).map((group) => {
                  if (groupedDocuments[group].length === 0) return null;
                  return (
                    <DocumentGroup
                      name={group}
                      documents={groupedDocuments[group]}
                      onDownload={(data) => this.onClick(data)}
                      {...{ onDeleteDocument, user }}
                      onClick={(idx, url, isImage) =>
                        this.onImageClicked(idx, url, isImage)
                      }
                    />
                  );
                })}
                {General.length > 0 && (
                  <DocumentGroup
                    name="General"
                    documents={General}
                    onDownload={(data) => this.onClick(data)}
                    {...{ onDeleteDocument, user }}
                    onClick={(idx, url, isImage) =>
                      this.onImageClicked(idx, url, isImage)
                    }
                  />
                )}
              </>
            )}
            {isOpen && (
              <ReusableLightbox
                isOpen={isOpen}
                onClose={() => this.setState({ isOpen: false })}
                image={selectedImage}
              />
            )}
          </>
        ) : (
          <Empty
            headline={`No ${labelName} yet`}
            strapline={`All ${labelName} you add will be listed here so it’s easier for you to manage.`}
            searchIsActive={search && search.documents ? search.documents : ''}
            cta={
              this.props.user.roles[0].role.name === 'Strata Manager' ||
              this.props.user.roles[0].role.name === 'Home Owner' ||
              user.roles[0].role.name === 'Realtor' ||
              (homeOwnerCheck &&
                localStorage.getItem('theme') === 'Rize') ? null : (
                <div>
                  <Button
                    color="teal"
                    label={`Add ${labelName}`}
                    onClick={() => {
                      this.setState({ showOverlay: true });
                      clearFndFormData();
                    }}
                    icon={
                      <Icon glyph="file-contract" weight="light" size="small" />
                    }
                    size="small"
                  />
                </div>
              )
            }
            image={
              <img
                alt={`No ${labelName} yet`}
                src="/assets/empty/documents.svg"
              />
            }
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={
            <DocumentForm
              onSaveDocument={onSaveDocument}
              from={this.props.from}
              breadcrumb={breadcrumb}
              user={user}
              onClose={() =>
                this.setState({ showOverlay: false }, () => clearFndFormData())
              }
            />
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  search: selectSearch(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clearFndFormData,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(Documents);
